import { createAsyncThunk } from '@reduxjs/toolkit';

const updateTeamAICount = createAsyncThunk(
  'user/updateTeamAICount',
  async (data) => data,
);

export default updateTeamAICount;
